import React, { useState } from 'react';
import { X } from 'lucide-react';
import { galleryImages } from '../data/mock';

const GallerySection = () => {
  const [selectedImage, setSelectedImage] = useState(null);

  return (
    <section id="galeria" className="section-padding bg-stone-50 relative overflow-hidden" aria-labelledby="gallery-heading">
      <div className="container mx-auto px-6">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="text-amber-700 font-medium tracking-widest uppercase text-sm">
            Nossos Pratos
          </span>
          <h2 id="gallery-heading" className="font-serif text-4xl md:text-5xl lg:text-6xl font-bold text-neutral-900 mt-4 mb-6">
            Galeria de Fotos
          </h2>
          <div className="w-24 h-1 bg-gradient-to-r from-amber-700 to-amber-500 mx-auto mb-6" />
          <p className="text-neutral-600 text-lg max-w-2xl mx-auto">
            Explore nossa coleção de imagens e descubra a arte por trás de cada prato do restaurante japonês Japamix em Anápolis.
          </p>
        </div>

        {/* Gallery Grid */}
        <div className="grid grid-cols-2 md:grid-cols-3 gap-4" role="list">
          {galleryImages.map((image, index) => (
            <figure
              key={image.id}
              className={`relative overflow-hidden rounded-xl cursor-pointer group aspect-square ${index === 0 ? 'col-span-2 md:row-span-2' : ''
                }`}
              onClick={() => setSelectedImage(image)}
              role="listitem"
            >
              <img
                src={image.url}
                alt={image.alt}
                className="absolute inset-0 w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                loading="lazy"
              />
              <figcaption className="absolute inset-0 bg-black/0 group-hover:bg-black/40 transition-all duration-300 flex items-center justify-center">
                <span className="text-white font-medium opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  Ver Foto
                </span>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>

      {/* Lightbox */}
      {selectedImage && (
        <div
          className="fixed inset-0 bg-black/95 z-50 flex items-center justify-center p-4 animate-fade-in"
          onClick={() => setSelectedImage(null)}
          role="dialog"
          aria-label="Visualização de imagem"
        >
          <button
            className="absolute top-6 right-6 text-white hover:text-amber-500 transition-colors"
            onClick={() => setSelectedImage(null)}
            aria-label="Fechar visualização"
          >
            <X size={32} />
          </button>
          <img
            src={selectedImage.url}
            alt={selectedImage.alt}
            className="max-w-full max-h-[90vh] object-contain rounded-lg animate-scale-in"
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      )}
    </section>
  );
};

export default GallerySection;
